// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__qHHkk","inboxContainer":"Main_inboxContainer__1yeeS"};